module.exports = __webpack_public_path__ + "img/inactive-status.91bf8dfc.svg";